import { useState, useCallback } from 'react';

import { entryService, CfProductAccessory, sortByOriginalList } from 'ggApp/modules/contentful';

export interface Image {
    url: string;
    contentType: string;
    image: string;
    title: string;
}

export interface Accessory {
    name: string;
    label: string;
    image: Image;
}

export interface FetchAccessoriesPayload {
    accessories: Accessory[];
    loading: boolean;
    fetchAccessories: (accessoryNames: string[], language: string) => void;
    loaded: boolean;
    reset: () => void;
}

const useFetchAccessories = (): FetchAccessoriesPayload => {
    const [accessories, setAccessories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const reset = useCallback(() => {
        setLoaded(false);
        setLoading(false);
        setAccessories([]);
    }, []);

    const fetchAccessories = useCallback(
        (accessoryNames: string[], language: string): void => {
            if (loading) {
                return;
            }

            setLoading(true);
            setLoaded(false);

            entryService
                .getCfEntriesByNames(CfProductAccessory.contentType, accessoryNames, language)
                .then((result: Accessory[]) => sortByOriginalList(accessoryNames, result))
                .then((items: Accessory[]) => items.map(CfProductAccessory.mapCfEntity))
                .then(setAccessories)
                .then(() => setLoaded(true))
                .finally(() => setLoading(false));
        },
        [loading],
    );

    return {
        accessories,
        loading,
        fetchAccessories,
        loaded,
        reset,
    };
};

export default useFetchAccessories;
